/* unplugin-vue-components disabled */import { render } from "./input-recorder.vue?vue&type=template&id=780512a8&scoped=true"
import script from "./input-recorder.vue?vue&type=script&lang=js"
export * from "./input-recorder.vue?vue&type=script&lang=js"

import "./input-recorder.vue?vue&type=style&index=0&id=780512a8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780512a8"],['__file',"src/components/chat-input-v2/input-recorder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "780512a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('780512a8', __exports__)) {
    api.reload('780512a8', __exports__)
  }
  
  module.hot.accept("./input-recorder.vue?vue&type=template&id=780512a8&scoped=true", () => {
    api.rerender('780512a8', render)
  })

}


export default __exports__